import './styles.scss'

import { BeefyButton } from '@enkla-gui'
import React from 'react'
import { date } from '@/_helpers'
import moment from 'moment'
import { useHistory } from 'react-router-dom'

const getDefiniteEntityTypeName = typeName => {
  if (!typeName) return ''

  // Handle words like "Villa" -> "Villan" by only appending "n"
  if (typeName.match(/a$/i)) {
    return `${typeName}n`
  }

  // Fallback for other types, e.g. "Lägenhet" -> "Lägenheten"
  return `${typeName}en`
}

export default function EntityLeaseStatus(props) {
  const history = useHistory()
  return (
    <div class='component_EntityLeaseStatus mb-15'>
      <div class='row'>
        <div class='col'>
          {props?.entity?.leases?.map(lease => {
            switch (lease.state.status) {
              case 'active':
                return (
                  <BeefyButton
                    _default={{
                      text: `${getDefiniteEntityTypeName(props.entity.type.name)} är uthyrd till ${lease.primary_tenant.name}`,
                      icon: lease.state.icon
                    }}
                    hover={{
                      text: 'Visa uthyrning',
                      icon: 'far fa-arrow-alt-circle-right'
                    }}
                    _class='mb-2'
                    type={lease.state.color}
                    callback={() => history.push(`/lease/${lease.id}`)}
                  />
                )

              case 'ending':
                return (
                  <BeefyButton
                    _default={{
                      text: `Uthyrning till ${lease.primary_tenant.name} upphör (${date.short(lease.stop)})`,
                      icon: lease.state.icon
                    }}
                    _class='mb-2'
                    hover={{
                      text: 'Visa uthyrning',
                      icon: 'far fa-arrow-alt-circle-right'
                    }}
                    type={lease.state.color}
                    callback={() => history.push(`/lease/${lease.id}`)}
                  />
                )

              case 'planned':
                return (
                  <BeefyButton
                    _default={{
                      text: `Uthyrning till ${lease.primary_tenant.name} planerad (${date.short(lease.start)}${lease.stop ? ' - ' + date.short(lease.stop) : ''
                        })`,
                      icon: lease.state.icon
                    }}
                    _class='mb-2'
                    hover={{
                      text: 'Visa uthyrning',
                      icon: 'fas fa-arrow-alt-circle-right'
                    }}
                    type={lease.state.color}
                    callback={() => history.push(`/lease/${lease.id}`)}
                  />
                )
              default:
                return ''
            }
          })}
          {!props.entity.rental_block && (
            <BeefyButton
              _default={{
                text: 'Skapa Uthyrning',
                icon: 'fas fa-home'
              }}
              hover={{
                text: 'Hyr ut',
                icon: 'fas fa-key'
              }}
              type='info'
              callback={() => history.push({ pathname: '/lease/create', entity: props.entity })}
            />
          )}
        </div>
      </div>
    </div>
  )
}
